import React from 'react';
import { FileSpreadsheet } from 'lucide-react';
import type { PreviewContact } from '../../../types/import';

interface ContactPreviewProps {
  contacts: PreviewContact[];
  duplicates: Set<string>;
}

export default function ContactPreview({ contacts, duplicates }: ContactPreviewProps) {
  return (
    <div className="space-y-4">
      <div className="border border-dark-700 rounded-lg overflow-hidden">
        <table className="w-full">
          <thead className="bg-dark-700">
            <tr>
              <th className="px-4 py-2 text-left">First Name</th>
              <th className="px-4 py-2 text-left">Last Name</th>
              <th className="px-4 py-2 text-left">Email</th>
              <th className="px-4 py-2 text-left">Phone</th>
              <th className="px-4 py-2 text-left">Status</th>
            </tr>
          </thead>
          <tbody>
            {contacts.slice(0, 5).map((contact, idx) => {
              const key = `${contact.first_name}-${contact.last_name}-${contact.personal_email || contact.work_email}`;
              const isDuplicate = duplicates.has(key);

              return (
                <tr key={idx} className="border-t border-dark-700">
                  <td className="px-4 py-2">{contact.first_name}</td>
                  <td className="px-4 py-2">{contact.last_name}</td>
                  <td className="px-4 py-2">
                    {contact.personal_email || contact.work_email}
                  </td>
                  <td className="px-4 py-2">
                    {contact.phone_number || contact.work_phone}
                  </td>
                  <td className="px-4 py-2">
                    {isDuplicate && (
                      <span className="text-yellow-500 text-sm">Possible duplicate</span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      
      <div className="text-sm text-gray-400">
        <FileSpreadsheet className="w-4 h-4 inline-block mr-2" />
        {contacts.length} contacts found
        {contacts.length > 5 && ' (showing first 5)'}
      </div>
    </div>
  );
}